import { render } from "./RefreshButton.vue?vue&type=template&id=0dc32d74&scoped=true"
import script from "./RefreshButton.vue?vue&type=script&lang=js"
export * from "./RefreshButton.vue?vue&type=script&lang=js"

import "./RefreshButton.vue?vue&type=style&index=0&id=0dc32d74&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc32d74"]])

export default __exports__